import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import c from 'classnames';
import { motion } from 'framer-motion';
import { CSSTransition } from 'react-transition-group';
import { styled, css } from 'styled-components';
import { Media } from '../../theme/Media';
import { useTableContext } from './context';
import TbodySeparator from './TbodySeparator';
import Td, { Wrapper as TdWrapper } from './Td';
import Tr, { Wrapper as TrWrapper } from './Tr';
export const Wrapper = styled.tbody `
  outline: ${({ $isOpen, theme }) => $isOpen && `2pt solid ${theme.colors.main}`};
  outline-offset: 2px;
  @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.mdMax : Media.lgMax)} {
    display: flex;
    flex-direction: column;
    margin-bottom: ${({ $isOpen }) => ($isOpen ? '10px' : '4px')};
    width: 100%;
    background: ${({ theme }) => theme.colors.grey00_1};
    ${({ $isOpen, $inGroup, theme }) => !$isOpen &&
    css `
        border-radius: ${$inGroup ? '0px' : '4px'};
        border: 1px solid ${theme.colors.grey10_1};
        ${theme.shadows.shadowTuna};
      `}
    > ${TrWrapper} {
      margin-bottom: 0;
      > ${TdWrapper} {
        background: transparent;
      }
    }
  }
  @media ${Media.mdMin} {
    @media ${({ $isCollapsedNav }) => ($isCollapsedNav ? Media.mdMax : Media.lgMax)} {
      > ${TrWrapper} {
        width: 100%;
        &:nth-child(even) {
          margin-left: 0;
        }
      }
    }
  }
`;
const MotionDiv = styled(motion.div ?? 'div') ``;
const subContentAnimate = {
    open: {
        height: 'auto',
        transition: {
            type: 'spring',
            damping: 10,
            mass: 0.5,
        },
        transitionEnd: {
            overflow: 'visible',
        },
    },
    closed: {
        height: 0,
        overflow: 'hidden',
        transition: {
            damping: 10,
            mass: 0.5,
        },
    },
};
const Tbody = ({ isOpen, subContent, children, dataTestId, onClick, className, inGroup = false }) => {
    const { isCollapsedNav } = useTableContext();
    return (_jsxs(_Fragment, { children: [!!(isOpen && subContent) && _jsx(TbodySeparator, {}), _jsxs(Wrapper, { className: c(className, inGroup && '_in-group', isOpen && '_is-open'), "$isOpen": !!(subContent && isOpen), "$inGroup": inGroup, onClick: onClick, "data-testid": dataTestId, "$isCollapsedNav": isCollapsedNav, children: [children, subContent && (_jsx(CSSTransition, { in: isOpen, timeout: 300, unmountOnExit: true, children: _jsx(Tr, { children: _jsx(Td, { type: 'sub', children: _jsx(MotionDiv, { animate: isOpen ? 'open' : 'closed', variants: subContentAnimate, initial: 'closed', children: subContent }) }) }) }))] }), !!(isOpen && subContent) && _jsx(TbodySeparator, {})] }));
};
export default React.memo(Tbody);
